<template>
  <div class="mod-joylearning__offringlist}">
    <div class="pkg-search-box">
      <el-form
        class="pkg-content"
        label-width="auto"
        label-position="top"
        :model="dataForm"
        ref="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-row class="margb10">
          <el-col :span="5" class="padt5">
            <!-- 平账单号 -->
            <el-form-item label="平账编号">
              <el-input
                v-model="dataForm.balanceAccountNo"
                :placeholder="$t('请输入')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" class="padt5">
            <!-- 平账标题 -->
            <el-form-item label="平账标题">
              <el-input
                v-model="dataForm.balanceAccountTitle"
                :placeholder="$t('请输入')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" class="padt5">
            <!-- 培训记录编号 -->
            <el-form-item label="培训记录编号">
              <el-input
                v-model="dataForm.trainingKey"
                :placeholder="$t('请输入')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" class="padt5">
            <!-- 排期编号 -->
            <el-form-item label="排期编号">
              <el-input
                v-model="dataForm.offeringNo"
                :placeholder="$t('请输入')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!-- 查询 -->
            <el-button
              class="M-search"
              style="margin-bottom: 7px"
              type="primary"
              @click="getDataListMerge"
              >{{ $t("query") }}</el-button
            >
            <!-- 重置 -->
            <el-button
              class="el-back M-search M-margin-l"
              type="info"
              @click="again"
              >{{ $t("reset") }}</el-button
            >
          </el-col>
        </el-row>
        <el-row class="margb10" v-show="isShow">
          <el-col :span="10" class="padt5">
            <el-form-item style="width: 90% !important;" label="创建时间">
                <el-date-picker
                    @change="createTimeChange"
                    v-model="dataForm.createTime"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="-"
                    style="width: 100%"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10" class="padt5">
            <el-form-item style="width: 90% !important;" label="修改时间">
                <el-date-picker
                    @change="updateTimeChange"
                    v-model="dataForm.updateTime"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="-"
                    style="width: 100%"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="margb10" v-show="isShow">
          <el-col :span="5" class="padt5">
            <!-- 创建人 -->
            <el-form-item label="创建人">
              <el-input
                v-model="dataForm.createUser"
                :placeholder="$t('请输入')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" class="padt5">
            <!-- 结算状态 -->
            <el-form-item label="平账单状态">
              <el-select
                v-model="dataForm.balanceAcountStatus"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5" class="padt5">
            <!-- 平账类别 -->
            <el-form-item label="平账类别">
              <el-select
                v-model="dataForm.balanceAccountType"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in balanceAccountTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 展开显示更多 -->
        <ToggleDiv @toggle="toggle"></ToggleDiv>
      </el-form>
    </div>

    <div class="pkg-content">
      <div class="search">
        <!-- 新增 btnAdded -->
        <el-button type="primary" v-if="$hasPermission('AUTHHAND0001')" @click="handleAdd"
          >{{ $t("add") }}
            <el-tooltip
              class="item"
              placement="top"
            >
              <div slot="content">
                <ul>
                  <li>
                    报名时组织类型为经销商网点，且已结算的培训记录（包括结算金额为0的）。
                  </li>
                  <li>
                    手工平账或者状态修改后，无论是否已经发送给财务系统结算，都可以再次进行手工平账。
                  </li>
                  <li>
                    手工平账创建当天可以进行编辑和删除，已经发送给财务系统结算的只能查看。
                  </li>
                </ul>
              </div>
              <em style="color: #fff" class="el-icon-question"></em>

        </el-tooltip>
        </el-button>
    </div>
      <!-- 表头动态展示 -->
      <el-table
        v-loading="dataListLoading"
        ref="multipleTable"
        :data="dataList"
        border
        :row-style="{ height: 48 + 'px' }"
        :cell-style="{ padding: 0 + 'px' }"
      >
        <!-- 平帐单号 -->
        <el-table-column
          prop="balanceAccountNo"
          label="平账编号"
          header-align="center"
          align="center"
          min-width="160"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!--平账标题-->
        <el-table-column
          prop="balanceAccountTitle"
          label="平账标题"
          header-align="center"
          align="left"
          :show-overflow-tooltip="true"
          min-width="200"
        ></el-table-column>
        <!-- 结算状态 -->
        <el-table-column
          header-align="center"
          align="center"
          min-width="140"
          prop="balanceAcountStatus"
          :formatter="statusFormat"
        >
          <template slot="header">
              <div style="line-height: 1.15;display: block;">
                平账单状态
              <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top"
              >
                <template slot="content">
                  <div>待结算：全部培训记录都未送财务系统结算。</div>
                  <div>未完成：已经有发送给财务系统的培训记录，但尚未全部结算完成。</div>
                  <div>已完成：全部培训记录都已经发送财务系统结算完成。</div>
                </template>
                <img
                        style="width: 14px; height: 14px"
                        src="../../../../assets/img/learning/Scheduling/general_icon_question@1x.png"
                        alt=""
                />
              </el-tooltip>
              </div>
          </template>
        </el-table-column>
        <!-- 平账类别 -->
        <el-table-column
          prop="balanceAccountType"
          label="平账类别"
          header-align="center"
          align="center"
          min-width="160"
          :formatter="balanceAccountTypeFormat"
        >
        <template slot="header">
              <div style="line-height: 1.15;display: block;">
              平账类别
              <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top"
              >
                <template slot="content">
                  <div>价格变更：在手工平账管理中创建的平账单</div>
                  <div>培训状态修改：在修改已有平账记录的培训记录状态时创建的平帐单</div>
                </template>
                <img
                        style="width: 14px; height: 14px"
                        src="../../../../assets/img/learning/Scheduling/general_icon_question@1x.png"
                        alt=""
                />
              </el-tooltip>
              </div>
          </template>
        </el-table-column>
        <!--培训记录数-->
        <el-table-column
          label="培训记录数"
          prop="trainingNum"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          min-width="100"
        ></el-table-column>
        <!-- 补缴/退款 -->
        <el-table-column
          prop="amountType"
          label="补缴/退款"
          header-align="center"
          min-width="100"
          align="center"
          :show-overflow-tooltip="true"
        >
        <div slot-scope="scope">{{scope.row.amountType == 10 ? "补缴" : "退款"}}</div>
        </el-table-column>
        <!-- 平账总金额 -->
        <el-table-column
          prop="balanceAcountTotalAmount"
          label="平账总金额"
          header-align="center"
          min-width="100"
          align="right"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
             {{ scope.row.balanceAcountTotalAmount | formatMoney }}
          </template>
        </el-table-column>
        <!-- 创建人 -->
        <el-table-column
          prop="createUserName"
          label="创建人"
          header-align="center"
          align="center"
          min-width="100"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 创建时间 -->
        <el-table-column
          prop="createTime"
          label="创建时间"
          header-align="center"
          align="center"
          min-width="160"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 修改人 -->
        <el-table-column
          prop="updateUserName"
          label="修改人"
          header-align="center"
          align="center"
          min-width="100"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 修改时间 -->
        <el-table-column
          prop="updateTime"
          label="修改时间"
          header-align="center"
          align="center"
          min-width="160"
          :show-overflow-tooltip="true"
        ></el-table-column>

        <!--操作 -->
        <el-table-column
          :label="$t('offering.operation')"
          fixed="right"
          header-align="center"
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">
              <div>
                <span class="el-dropdown-link"
                      v-if="$hasPermission('AUTHHAND0002')"
                      @click="handleView(scope.row,scope.$index)">{{ $t('view') }}</span>
                <div class="pkg-vertical-divider" v-if="scope.row.balanceAcountStatus == 10 ? true : false"></div>
                <el-dropdown  v-if="scope.row.balanceAcountStatus == 10 ? true : false" trigger="click" placement="bottom">

                  <span class="el-dropdown-link" v-if="scope.row.balanceAcountStatus == 10 ? true : false">
                    {{ $t('offering.more') }}<em class="el-icon-caret-bottom el-icon--right"></em>
                  </span>
                  <el-dropdown-menu slot="dropdown" >
                    <!--编辑 && scope.row.startdate <= new Date() TODO:  -->
                    <el-dropdown-item v-if="$hasPermission('AUTHHAND0001')" @click.native="handleEdit(scope.row,scope.$index)">
                      {{ $t('offering.edit') }}
                    </el-dropdown-item>
                    <!--删除 -->
                    <el-dropdown-item v-if="$hasPermission('AUTHHAND0001')" @click.native="deleteAccount(scope.row)">
                      {{ $t('offering.listDelete') }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <el-dialog  :visible.sync="dialogVisible" :close-on-click-modal="true" :modal="true" :show-close="true" :center="true">
        <el-row>
          <el-col :span="24" style="height: 44px; margin: auto; text-align: center; font-weight: 700; font-size: 14px;">
            <p>以下培训记录正在处理结算账户，暂时不可修改平账单，请明日再试</p>
          </el-col>
        </el-row>
        <el-table :data="errorData"  style="width: 100%" :cell-style="cellStyle">
          <el-table-column min-width="40%" label="培训记录编号" header-align="center" align="center" show-overflow-tooltip prop="trainingKey"></el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ToggleDiv from '@/components/toggle-div'
import mixinViewModule from "@/mixins/view-module";
import joinBESTVue from '../../../protal/join-BEST.vue';
export default {
  mixins: [mixinViewModule],
  name: "handworkBalanceAccount",
  data() {
    return {
      errorData: [],
      dialogVisible: false,
      mixinViewModuleOptions: {
        getDataListURL: "/learning/account/queryBalanceAccount",
        getDataListIsPage: true,
      },
      isShow: false,
      dataList: [
      ],
      dataForm: {
        createTime: [],
        updateTime: [],
        balanceAccountNo: '',
        balanceAccountTitle: '',
        createUser: '',
        balanceAcountStatus: '',
        balanceAccountType: '',
        trainingKey: '',
        offeringNo: ''
      },
      deleteForm: {
        id: "",
        sourceId: "",
        balanceAccountNo: "",
        balanceAccountTitle: "",
        amountType: "",
        balanceAccountType: "",
        singleAmount: "",
        balanceDes: "",
        fileList: [],
        trainingRecordList: [],
      },
      emptyForm: {
        balanceAccountNo: "",
        balanceAccountTitle: "",
        balanceAcountUpdateUser: "",
        balanceAcountStatus: "",
        beginCreateTime: "",
        endCreateTime: "",
        beginUpdateTime: "",
        endUpdateTime: "",
        balanceAccountType: ""
      },
      statusList: [
        { label: "待结算", value: "10" },
        { label: "未完成", value: "20" },
        { label: "已完成", value: "30" },
      ],
      balanceAccountTypeList: [
        { label: "价格变更", value: "10" },
        { label: "培训状态修改", value: "20" },
      ],
      deleteUrl: "/learning/account/deleteAccount"
    };
  },
  components:{
    ToggleDiv
  },
  created() {
    this.dataForm = JSON.parse(JSON.stringify(this.emptyForm))
  },
  filters: {
  rounding (value) {
    return value.toFixed(2)
    },
    formatMoney(num) {
      if (!num && num !== 0 && num !== '0') {
        return ''
      }
      num = num.toString().replace(/\$|\,/g, '')
      if (isNaN(num)) {
        num = '0'
      }
      let sign = num == (num = Math.abs(num))
      num = Math.floor(num * 100 + 0.50000000001)
      let cents = num % 100
      num = Math.floor(num / 100).toString()
      if (cents < 10) {
        cents = '0' + cents
      }
      for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3))
      }
      return (sign ? '' : '-') + num + '.' + cents
    }
  },
  methods: {
    formatMoney(num) {
      if (!num && num !== 0 && num !== '0') {
        return ''
      }
      num = num.toString().replace(/\$|\,/g, '')
      if (isNaN(num)) {
        num = '0'
      }
      let sign = num == (num = Math.abs(num))
      num = Math.floor(num * 100 + 0.50000000001)
      let cents = num % 100
      num = Math.floor(num / 100).toString()
      if (cents < 10) {
        cents = '0' + cents
      }
      for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3))
      }
      return (sign ? '' : '-') + num + '.' + cents
    },
    // 查询
    getDataListMerge() {
      this.page = 1;
      this.getDataList();
    },
    getDataList() {
      this.dataListLoading = true
      this.$request.get(
                  this.mixinViewModuleOptions.getDataListURL,
                  {
                    page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
                    limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
                    ...this.dataForm
                  }
                ).then((res, total, code, data) => {
                  console.log(data)
                  this.dataList = data.data.records
                  this.total = this.mixinViewModuleOptions.getDataListIsPage ? parseInt(data.data.total, 10) : 0
                  this.dataListLoading = false
                }).catch(() => {
                  this.dataListLoading = false
                })
    },
    // 重置
    again() {
      this.dataForm = JSON.parse(JSON.stringify(this.emptyForm))
      this.page = 1;
      this.createTime = [];
      this.updateTime = [];
      this.getDataList();
    },
    toggle(val) {
      this.isShow = val
    },
    createTimeChange() {
            if (this.createTime && this.createTime.length > 1) {
                this.dataForm.beginCreateTime = this.createTime[0];
                this.dataForm.endCreateTime = this.createTime[1];
            } else {
                this.dataForm.beginCreateTime = '';
                this.dataForm.beginCreateTime = '';
            }
        },
    updateTimeChange() {
        if (this.updateTime && this.updateTime.length > 1) {
            this.dataForm.beginUpdateTime = this.updateTime[0];
            this.dataForm.endUpdateTime = this.updateTime[1];
        } else {
            this.dataForm.beginUpdateTime = '';
            this.dataForm.endUpdateTime = '';
        }
    },
    handleAdd() {
      this.$router.push({
        name: "charge-handworkBalanceAccount-add-or-update",
        query: {}
      });
      this.$eventHub.$emit('handwork_balance_account', 'add');
    },
    handleView(row,id) {
      this.$router.push({
        name: "charge-handworkBalanceAccount-view",
        query: {
          id: id,
          data: row
        },
      });
    },
    handleEdit(row,id) {
      this.$router.push({
        name: "charge-handworkBalanceAccount-add-or-update",
        query: {
          id: id,
          data: row
        },
      });
      this.$eventHub.$emit('handwork_balance_account', 'edit');
    },
    deleteAccount(row){
      this.$confirm(
        this.$t('prompt.info', { handle: this.$t('delete') }),
        this.$t('prompt.title'),
        {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel')
        }
      )
        .then(() => {
      this.dataListLoading = true
      this.deleteForm = row
      this.$request.post(
                  this.deleteUrl,
                    this.deleteForm
                ).then((res, total, code, data) => {
                    if (data.msg != 'success') {
                      if (data.msg == "以下培训记录正在处理结算账户，暂时不可修改平账单，请明日再试") {
                        this.dialogVisible = true
                        this.errorData = data.data.accountErrorDTOS
                        this.dataListLoading = false
                      } else {
                        return this.$message.error(data.msg)
                        //this.dataListLoading = false
                      }
                    } else {
                      this.$message({
                        message: '删除成功',
                        type: 'success',
                        duration: 1500,
                      })
                      this.getDataList();
                    }
                }).catch(() => {
                  this.dataListLoading = false
                })
        })
        .catch((err) => {
          console.log(err)
        })
    },
    statusFormat(row, column) {
      let obj = this.statusList.find((e) => {
        return e.value == row.balanceAcountStatus;
      });
      return obj ? obj.label : " ";
    },
    balanceAccountTypeFormat(row, column) {
      let obj = this.balanceAccountTypeList.find((e) => {
        return e.value == row.balanceAccountType;
      });
      return obj ? obj.label : " ";
    },
    checkDate(row) {
      if (row.createTime != null) {
        let date1 = new Date(row.createTime)
        if (this.dateFormat(date1) == this.dateFormat(new Date())) {
                return true
        } else {
          return false
        }
      }
    },
    dateFormat(date) {
        let seperator1 = "-";
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        let currentdate = year + seperator1 + month + seperator1 + strDate;
        return currentdate;
    }
  },
  cellStyle({row, rowIndex}) {
    return 'border-right: initial !important; padding: 4px 0;'
  }
};
</script>

<style lang="scss" scoped>
@import "../../../css/pkg-styles.css";

.aui-wrapper .el-date-editor .el-range-separator {
  width: 30px;
}

.jieshu .el-form-item__content {
  width: 94.5%;
}

.kaishi .el-form-item__content {
  width: 111%;
}

.el-row {
  margin-bottom: 0px;
}

#container {
  display: -webkit-flex;
}

.el-date-editor.el-input {
  width: 150px;
}

.search-item {
  width: 94% !important;
  min-width: 290px;
}

.search {
  height: 50px;
}

.wrapper-div {
  .el-dialog__title {
    text-align: center;
    display: block;
  }
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

 .search-item .el-form-item__content {
  margin-left: 96px !important;
}
.el-tooltip__popper.is-dark .el-tooltip__popper {
  max-width: 500px !important;
}
.margb10 {
  min-height: 75px;
}
</style>
